
<template>

    <div :class="['pdf-troskovnik']">
        <div id="scroll-here" class="general-wrapper">
            <div class="top-troskovnik">
                <a @click="goBack()" class="entry-exit"><img src="@/assets/img/entry_form_close.svg" /></a>
            <div class="top-left">
                <p>
                    SJEDIŠTE/HEAD OFFICE<br>
                    42000 Varaždin, Hrvatska (Croatia)<br>
                    Kolodvorska 12 (Dvor Ratimir)<br>
                    T: +385 42 373 100; F: +385 42 213 731
                </p>
            </div>
            <div class="top-logo">
                <img src="@/assets/img/probija_logo.svg">
            </div>
            <div class="top-right">
                    <p>
                        PISARNICA ZAGREB/ZAGREB OFFICE<br>
                        10000 Zagreb, Hrvatska (Croatia)<br>
                        Slavonska avenija 1/B (Matrix Office Park B)<br>
                        T: +385 1 6465 570; F: +385 1 6465 571
                    </p>
            </div>
            </div>
            <div class="tuzitelj-tuzenici">
                <div class="tuzitelj-info">
                    <h3 class="tuzitelj-title">{{troskovnik_data.stranke_naslov}}</h3>
                    <div  v-for="(st,key) in troskovnik_data.stranke" :key="key">
                        <p v-if="st.name != ''">
                            <b>{{st.name}}</b>
                        </p>
                        <p v-if="st.details != ''" class="t-grey">
                            {{st.details}}
                        </p>
                    </div>
                </div>
                <div class="tuzenici-info">
                    <h3 class="tuzitelj-title">{{troskovnik_data.protustranke_naslov}}</h3>
                    <div  v-for="(st,key) in troskovnik_data.protustranke" :key="key">
                        <p v-if="st.name != ''">
                            <b>{{st.name}}</b>
                        </p>
                        <p v-if="st.details != ''" class="t-grey">
                            {{st.details}}
                        </p>
                    </div>
                </div>
            </div>
            <div class="troskovnik-central-wrapper">
                <div class="troskovnik-c-top">
                    <div class="troskovnik-c-top-l">
                        <h2>{{troskovnik_data.naslov != '' ? troskovnik_data.naslov : 'Troškovnik'}}</h2>
                        <p class="t-grey"><b>Na posl. broj predmeta: {{troskovnik_data.poslBr}}</b></p>
                    </div>
                    <div class="troskovnik-c-top-r">
                        <p>Varaždin: {{getDatum(today_date)}}</p>
                        <!-- <p>Oznaka: {{troskovnik_data.oznaka}}</p> -->
                        <p>{{troskovnik_data.nadlezno_tijelo}}</p>
                    </div>
                </div>
                <!-- <div class="troskovnik-c-table">
                    <div class="t-r-1 t-r">
                        <div class="t-s-1 t-s">#</div>
                        <div class="t-s-2 t-s">OPIS</div>
                        <div class="t-s-3 t-s">CIJENA</div>
                    </div>
                    <div class="t-r-2 t-r">
                        <div class="t-s-1 t-s">01</div>
                        <div class="t-s-2 t-s">Sastav odgovora na tužbu od 04.01.2017.g., Tbr.8.st.1. OT, 6060</div>
                        <div class="t-s-3 t-s">60.600,00 kn</div>
                    </div>
                    <div class="t-r-3 t-r">
                        <div class="t-s-1 t-s">02</div>
                        <div class="t-s-2 t-s">Sastav podneska od 31.07.2017.g. Tbr.8.1. OT, 6060 b</div>
                        <div class="t-s-3 t-s">60.600,00 kn</div>
                    </div>
                    <div class="t-r-4 t-r">
                        <div class="t-s-1 t-s">03</div>
                        <div class="t-s-2 t-s">Sastav podneska od 04.06.2018.g. Tbr.8.3. OT, 50</div>
                        <div class="t-s-3 t-s">500,00 kn</div>
                    </div>
                    <div class="t-r-5 t-r">
                        <div class="t-s-1 t-s">04</div>
                        <div class="t-s-2 t-s">Zastupanje na ročištu od 16.10.2018.g., Tbr. 9.2. OT, 50% od 6060 b</div>
                        <div class="t-s-3 t-s">30.300,00 kn</div>
                    </div>
                    <div class="t-r-6 t-r">
                        <div class="t-s-1 t-s">05</div>
                        <div class="t-s-2 t-s">Sastav podneska od 29.01.2019.g., Tbr. 8.3. OT, 50b</div>
                        <div class="t-s-3 t-s">60.600,00 kn 
                        </div>
                    </div>
                    <div class="t-r-7 t-r">
                        <div class="t-s-1 t-s">06</div>
                        <div class="t-s-2 t-s">Zastupanje na ročištu od 26.7.2019.g., Tbr. 9.1. OT,</div>
                        <div class="t-s-3 t-s">60.600,00 kn </div>
                    </div>
                    <div class="table-sum">
                        <div class="t-sum-red1 t-r">
                            <div class="t-s-s1 t-s">ukupno</div>
                            <div class="t-s-s2 t-s">274.200,00</div>
                        </div>
                        <div class="t-sum-red2 t-r">
                            <div class="t-s-s1 t-s">pdv 25%</div>
                            <div class="t-s-s2 t-s">68.550,00</div>
                        </div>
                        <div class="t-sveukupno t-r">
                            <div class="t-s-s1 t-s">sveukupno</div>
                            <div class="t-s-s2 t-s">345.250,00 kn</div>
                        </div>
                    </div>
                </div> -->
                <div class="troskovnik-c-table">
                    <div class="t-r-1 t-r">
                        <div class="t-s-1 t-s">#</div>
                        <div class="t-s-2 t-s">OPIS</div>
                        <div class="t-s-3 t-s">CIJENA</div>
                    </div>
                    <div v-for="(st,key) in all_rows" :key="key" class="t-r-2 t-r">
                        <div class="t-s-1 t-s">{{key+1}}</div>
                        <div class="t-s-2 t-s">{{`${st.opis}`}}</div>
                        <div class="t-s-3 t-s">{{st.iznos.toFixed(2).toString().replaceAll('.', ',').replace(/(\d)(?=(\d{3})+(?:\,\d+)?$)/g,"$1.")}}{{!st.VAT_incl ? '*':''}} EUR</div>
                    </div>
                    <div class="table-sum">
                        <div class="t-sum-red1 t-r">
                            <div class="t-s-s1 t-s">ukupno</div>
                            <div class="t-s-s2 t-s">{{sum_noVAT.toFixed(2).toString().replaceAll('.', ',').replace(/(\d)(?=(\d{3})+(?:\,\d+)?$)/g,"$1.")}} EUR</div>
                        </div>
                        <div class="t-sum-red2 t-r">
                            <div class="t-s-s1 t-s">pdv 25%</div>
                            <div class="t-s-s2 t-s">{{sum_VAT.toFixed(2).toString().replaceAll('.', ',').replace(/(\d)(?=(\d{3})+(?:\,\d+)?$)/g,"$1.")}} EUR</div>
                        </div>
                        <div class="t-sveukupno t-r">
                            <div class="t-s-s1 t-s">sveukupno</div>
                            <div class="t-s-s2 t-s">{{troskovnik_data.total.toFixed(2).toString().replaceAll('.', ',').replace(/(\d)(?=(\d{3})+(?:\,\d+)?$)/g,"$1.")}} EUR</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="bottom-potpis">
                <!-- <p>Za tuženika punomoćnica:</p>
                <p class="t-grey potpis">Suzana Cesarec Nothig, odvjetnica</p> -->
                <p>{{troskovnik_data.punomoćnik_naslov}}</p>
                <p class="t-grey potpis">{{troskovnik_data.punomoćnik_osoba}}</p>
            </div>
        </div>
        <div class="footer">
            <p>Odvjetnici-partneri / Firm Partners: Marko Porobija, Marko Benčić, Suzana Cesarec Nothig, Romina Štaba univ.spec.iur.</p>
            <p>Odvjetnici / Attorneys: Maja Kauzler-Geček, Nela Pilipović Ramušćak, Luka Porobija, Irena Vadas, Nebojša Vitez</p>
            <p>Odvjetnički vježbenici / Junior Associates: Mirna Mikulek, Marko Đurić</p>
        </div>
    </div>

</template>

<script>
import moment from "moment";
import $ from 'jquery';
import gsap from 'gsap';

export default {
    data() {
        return {
            troskovnik_data:{            
                vrsta_naplate:{ID:1},
                naslov:{value:''},
                poslBr:{value:''},
                // oznaka:{value:''},
                nadlezno_tijelo:{value:''},
                VPS:{drop_value:1,input_value:0},
                fiksne_stavke:[],
                uspjeh_value:'',
                uspjeh_postotak:'',
                prostojbe:[],
                vjestacenje:[],
                ostali_troskovi:[],
                total:0,
            },
            row_num:0,
            today_date:'',
            all_rows:[],
            sum_VAT:0,
            sum_noVAT:0
        }
    },
    methods: {
        getDatum(date){
            return moment(date).format("DD.MM.yyyy.");
        },
        getRowNum(){
            this.row_num+=1;
            return this.row_num;
        },
        goBack(){
            console.log(this.$route);
            this.$router.go(-1);
            // this.$router.push('/case/'+this.$route.params.uid);
        }
    },
    mounted() {
        this.today_date = Date.now();
        document.body.classList.add("new-entry");
        document.getElementsByClassName('pdf-troskovnik')[0].classList.remove("router-wrapper")
        if (this.$store.state.troskovnik_data == null) {
            this.$router.go(-1);
        }
        else{
            this.troskovnik_data = this.$store.state.troskovnik_data;
            if(this.troskovnik_data.uspjeh_uk > 0 && this.troskovnik_data.naplata_type !=2){
                this.sum_VAT += parseFloat(this.troskovnik_data.uspjeh_uk)*0.25;
                this.sum_noVAT += parseFloat(this.troskovnik_data.uspjeh_uk);
                this.all_rows.push({opis:`Po uspjehu - ${this.troskovnik_data.uspjeh.uspjeh_postotak}% od vrijednosti ${this.troskovnik_data.uspjeh.uspjeh_value} EUR`,iznos:parseFloat(this.troskovnik_data.uspjeh_uk),VAT_incl:false})
            }
            if(this.troskovnik_data.naplata_type != 1){
                this.all_rows = this.all_rows.concat(this.troskovnik_data.fiksne_stavke.filter(i=>i.iznos !== "" && i.opis !== '').map((it)=>{
                    this.sum_VAT += parseFloat(it.iznos)*0.25;
                    this.sum_noVAT += parseFloat(it.iznos);
                    return {opis:it.tbrovi+it.opis+' - '+this.getDatum(it.datum),iznos:parseFloat(it.iznos),VAT_incl:false}
                }))
            }
            this.all_rows = this.all_rows.concat(this.troskovnik_data.pristojbe.filter(i=>i.iznos !== "" && i.opis !== '').map((it)=>{
                this.sum_noVAT += parseFloat(it.iznos);
                return {opis:'Pristojba - '+it.opis,iznos:parseFloat(it.iznos),VAT_incl:true}
            }))
            this.all_rows = this.all_rows.concat(this.troskovnik_data.vjestacenje.filter(i=>i.iznos !== "" && i.opis !== '').map((it)=>{
                this.sum_noVAT += parseFloat(it.iznos);
                return {opis:'Vještaćenje - '+it.opis,iznos:parseFloat(it.iznos),VAT_incl:true}
            }))
            this.all_rows = this.all_rows.concat(this.troskovnik_data.ostali_troskovi.filter(i=>i.iznos !== "" && i.opis !== '').map((it)=>{
                this.sum_noVAT += parseFloat(it.iznos);
                return {opis:'Ostali trošak - '+it.opis,iznos:parseFloat(it.iznos),VAT_incl:true}
            }))

        }
        $(".entry-exit").hover(
            function () {
                gsap.to($(this).find("img"), 0.3, {
                    rotation: 180,
                    transformOrigin: "center",
                });
            },
            function () {
                gsap.to($(this).find("img"), 0.5, {
                    rotation: -180,
                    transformOrigin: "center",
                });
            }
        );
        document.getElementById('scroll-here').scrollIntoView();
    },
    destroyed() {
        document.body.classList.remove("new-entry");
        document.getElementsByClassName('pdf-troskovnik')[0].classList.add("router-wrapper")
        $(".entry-exit").off();
    },
}
</script>